export var isJargonHubStoryContent = function(input) {
    var isJargonPage = Object.prototype.hasOwnProperty.call(input, "component") && input.component === "JargonPage";
    if (!isJargonPage) {
        console.error("Expected to find JargonPage component, instead received: \n ".concat(JSON.stringify(input, null, 2)));
    }
    return isJargonPage;
};
